import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BHAREE_BASE_URL_LOCAL } from "../../config/config.url";
import axios from "axios";
import isEmpty from "../../utils/is-Empty";
import Select from "react-select"; // for searchable dropdown

const CityPopup = ({ show, onHide }) => {
  const [otherCity, setOtherCity] = useState("");
  const [error, setError] = useState("");
  const [statesList, setStatesList] = useState([]);
  const [stateName, setStateName] = useState("");
  const [districtList, setDistrictList] = useState([]);
  const [districtName, setDistrictName] = useState("");
  const [cityList, setCityList] = useState([]);
  const [city, setCity] = useState("");
  const navigate = useNavigate();
  const { appconfig } = useSelector((state) => {
    return state;
  });

  let options = {
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.jwtToken}`,
    },
  };

  // ✅ Reset form every time popup is closed
  useEffect(() => {
    if (!show) {
      setStateName("");
      setDistrictName("");
      setCity("");
      setOtherCity("");
      setError("");
      setStatesList([]);
      setDistrictList([]);
      setCityList([]);
    } else {
      // Optionally, you can fetch geo data when the modal is shown
      getGeoDataDB("state");
    }
  }, [show]);

  // Find fulfillment cities from appconfig and keep it in state
  const [fulfillmentCities, setFulfillmentCities] = useState([]);
  useEffect(() => {
    if (appconfig?.data?.length > 0) {
      const cities =
        appconfig.data.find((item) => item.name === "fulfillment_cities")?.value?.split(",") || [];
      setFulfillmentCities(cities);
    }
  }, [appconfig]);

  const getGeoDataDB = async (action, stateName, districtName) => {
    let apiURL = BHAREE_BASE_URL_LOCAL + "/api/geoDataDB?countryCode=IN";
    if (districtName) {
      apiURL += `&districtName=${encodeURIComponent(districtName)}`;
    }
    if (stateName) {
      apiURL += `&stateName=${encodeURIComponent(stateName)}`;
    }

    try {
      const res = await axios.get(apiURL, {
        headers: {
          ...options.headers,
          "x-guest-token": `${localStorage.guest_jwt_token}`,
        },
      });
      // console.log("GeoData Response: ", res);
      if (res.data.success) {
        if (action === "state") {
          setStatesList(res.data.data);
          return;
        }
        if (action === "district") {
          setDistrictList(res.data.data);
          return;
        }
        if (action === "city") {
          setCityList(res.data.data);
          return;
        }
      } else {
        console.error("Failed to fetch geo data:", res.data.message);
      }
    } catch (error) {
      console.error("Error fetching geo data:", error);
    }
  };

  const handleSubmit = () => {
    setError("");
    if (!stateName) {
      setError("Please select a state.");
      return;
    }
    if (!districtName) {
      setError("Please select a district.");
      return;
    }
    if (!city) {
      setError("Please select a city.");
      return;
    }

    // ✅ Updated navigation logic
    // If the selected city is in fulfillmentCities, go to booster, else leads
    if (!fulfillmentCities.includes(city)) {
      window.location.href = `/seller/subscription/leads?city=${encodeURIComponent(
        city
      )}&state=${encodeURIComponent(stateName)}&district=${encodeURIComponent(districtName)}`;
    } else {
      window.location.href = `/seller/subscription/booster?city=${encodeURIComponent(
        city
      )}&state=${encodeURIComponent(stateName)}&district=${encodeURIComponent(districtName)}`;
    }

    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} backdrop keyboard>
      <Modal.Header closeButton>
        <span className="fw-bold">Select your state, district and city</span>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>
              State <span className="text-danger">*</span>
            </Form.Label>
            <Select
              value={stateName ? { value: stateName, label: stateName } : null}
              onChange={(selected) => {
                setStateName(selected?.value || "");
                getGeoDataDB("district", selected?.value);
                setDistrictName("");
                setCity("");
                if (selected?.value !== "") {
                  setError("");
                }
              }}
              options={statesList.map((s) => ({
                value: s.state_name,
                label: s.state_name,
              }))}
              placeholder="-- Select State --"
              isSearchable={true}
              className="react-select-container"
              classNamePrefix="react-select-register"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              District <span className="text-danger">*</span>
            </Form.Label>
            <Select
              value={districtName ? { value: districtName, label: districtName } : null}
              onChange={(selected) => {
                setDistrictName(selected?.value || "");
                getGeoDataDB("city", stateName, selected?.value);
                setCity("");
              }}
              options={districtList.map((d) => ({
                value: d.district_name,
                label: d.district_name,
              }))}
              placeholder="-- Select District --"
              isSearchable={true}
              className="react-select-container"
              classNamePrefix="react-select-register"
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>
              City <span className="text-danger">*</span>
            </Form.Label>
            <Select
              value={city ? { value: city, label: city } : null}
              onChange={(selected) => {
                setCity(selected?.value || "");
              }}
              options={cityList.map((c) => ({
                value: c.city_name,
                label: c.city_name,
              }))}
              placeholder="-- Select City --"
              isSearchable={true}
              className="react-select-container"
              classNamePrefix="react-select-register"
            />
          </Form.Group>

          {/* {city === "Others" && (
            <Form.Group className="mt-3">
              <Form.Label>
                Enter City <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                value={otherCity}
                onChange={(e) => setOtherCity(e.target.value)}
                placeholder="Enter your city"
              />
            </Form.Group>
          )} */}
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleSubmit}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CityPopup;
